/* Reborn Naturals: small vanilla modules, one per section behaviour */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header shadow on scroll */
  const header = $('[data-header]');
  if (header) { const onScroll = () => header.classList.toggle('is-stuck', scrollY > 8); addEventListener('scroll', onScroll, { passive: true }); onScroll(); }

  /* mobile drawer */
  const drawer = $('[data-drawer]');
  const burger = $('[data-menu-open]');
  if (drawer && burger) {
  const openMenu = () => { drawer.hidden = false; burger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; $('[data-menu-close]', drawer).focus(); };
  const closeMenu = () => { drawer.hidden = true; burger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; };
  burger.addEventListener('click', openMenu);
  $$('[data-menu-close]', drawer).forEach(el => el.addEventListener('click', closeMenu));
  drawer.addEventListener('click', e => { if (e.target === drawer) closeMenu(); });
  addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hidden) closeMenu(); });
  }

  /* banner slideshow: swipe, arrows, dots, gentle autoplay */
  const banner = $('[data-banner]');
  if (banner) {
    const track = $('[data-banner-track]', banner);
    const dots = $$('[data-banner-dots] button', banner);
    const count = track.children.length;
    let idx = 0, timer;
    const go = i => { idx = (i + count) % count; track.scrollTo({ left: track.clientWidth * idx, behavior: reduce ? 'auto' : 'smooth' }); };
    const slides = [...track.children];
    let shown = -1;
    const sync = () => {
      idx = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, k) => d.setAttribute('aria-selected', k === idx));
      const cur = $('[data-banner-cur]', banner); if (cur) cur.textContent = String(idx + 1).padStart(2, '0');
      if (idx !== shown) {
        shown = idx;
        slides.forEach((s, k) => { const on = k === idx; s.classList.toggle('is-active', on); const tt = s.querySelector('.bslide__title'); if (tt) tt.classList.toggle('is-risen', on); });
      }
    };
    sync();
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); restart(); }));
    $$('[data-banner-dir]', banner).forEach(b => b.addEventListener('click', () => { go(idx + Number(b.dataset.bannerDir)); restart(); }));
    const restart = () => {
      clearInterval(timer); banner.classList.remove('is-run');
      if (reduce) return;
      void banner.offsetWidth; banner.classList.add('is-run');
      timer = setInterval(() => { if (!document.hidden) { go(idx + 1); banner.classList.remove('is-run'); void banner.offsetWidth; banner.classList.add('is-run'); } }, 5500);
    };
    banner.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { clearInterval(timer); banner.classList.remove('is-run'); } });
    banner.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') restart(); });
    track.addEventListener('touchstart', () => restart(), { passive: true });
    restart();
  }

  /* hero day dots: stagger */
  $$('.hero__dots i').forEach((d, i) => d.style.animationDelay = (i * 0.14) + 's');

  /* reveal on scroll */
  const io = new IntersectionObserver(entries => entries.forEach(en => {
    if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
  }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  $$('.reveal, .reveal-img').forEach(el => io.observe(el));

  /* trust strip becomes a gentle marquee on phones */
  const trust = $('[data-trust]');
  if (trust && matchMedia('(max-width: 900px)').matches && !reduce) {
    [...trust.children].forEach(li => { const c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); trust.appendChild(c); });
    trust.classList.add('is-marquee');
  }

  /* videos: lazy load + play only while visible */
  const vids = $$('video[data-src]');
  const vio = new IntersectionObserver(entries => entries.forEach(({ target: v, isIntersecting }) => {
    if (isIntersecting) {
      if (!v.src) { v.src = v.dataset.src; v.load(); }
      if (!reduce) v.play().catch(() => {});
    } else v.pause();
  }), { threshold: 0.35 });
  vids.forEach(v => vio.observe(v));

  /* sound toggle: one video with sound at a time */
  $$('[data-sound]').forEach(btn => btn.addEventListener('click', () => {
    const v = btn.parentElement.querySelector('video');
    const turnOn = v.muted;
    vids.forEach(o => { o.muted = true; });
    $$('[data-sound]').forEach(b => { b.innerHTML = '<svg class="ic"><use href="#i-mute"/></svg>'; b.setAttribute('aria-label', 'Turn sound on'); });
    if (turnOn) {
      v.muted = false; v.play().catch(() => {});
      btn.innerHTML = '<svg class="ic"><use href="#i-vol"/></svg>'; btn.setAttribute('aria-label', 'Turn sound off');
    }
  }));

  /* carousel arrows */
  $$('[data-car-nav]').forEach(nav => {
    const track = $(`[data-car="${nav.dataset.carNav}"] .car__track`);
    $$('button', nav).forEach(b => b.addEventListener('click', () => {
      const card = track.firstElementChild.getBoundingClientRect().width + 20;
      track.scrollBy({ left: card * Number(b.dataset.dir), behavior: reduce ? 'auto' : 'smooth' });
    }));
  });

  /* product tabs */
  const tabs = $$('[data-tab]');
  tabs.forEach(t => t.addEventListener('click', () => {
    tabs.forEach(o => {
      const on = o === t;
      o.classList.toggle('is-active', on);
      o.setAttribute('aria-selected', on);
      $('#panel-' + o.dataset.tab).hidden = !on;
    });
  }));

  /* reviews marquee: duplicate once for a seamless loop */
  $$('[data-marquee] .marquee__track').forEach(tr => {
    [...tr.children].forEach(c => { const k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); tr.appendChild(k); });
  });

  /* FAQs and accordions: opening one closes the others in the same list */
  document.addEventListener('toggle', e => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open || !d.matches('.faq, .acc')) return;
    [...d.parentElement.children].forEach(o => { if (o !== d && o.matches && o.matches('details[open]')) o.open = false; });
  }, true);

  /* nav highlight */
  const links = $$('.header__nav a');
  const sio = new IntersectionObserver(entries => entries.forEach(en => {
    if (en.isIntersecting) links.forEach(a => a.classList.toggle('is-active', a.getAttribute('href').endsWith('#' + en.target.id)));
  }), { rootMargin: '-45% 0px -50% 0px' });
  $$('main section[id]').forEach(s => sio.observe(s));

  /* mobile sticky buy bar: show after hero, hide near final CTA and footer */
  const bar = $('[data-sticky-buy]');
  const hero = $('.hero'), cta = $('.cta'), footer = $('.footer');
  if (bar && hero && cta && footer) {
  let heroGone = false, ctaIn = false;
  const setBar = () => { const on = heroGone && !ctaIn; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', !on); bar.querySelector('a').tabIndex = on ? 0 : -1; };
  new IntersectionObserver(([e]) => { heroGone = !e.isIntersecting; setBar(); }).observe(hero);
  const ctaObs = new IntersectionObserver(es => { ctaIn = es.some(e => e.isIntersecting) || [cta, footer].some(el => { const r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; }); setBar(); });
  ctaObs.observe(cta); ctaObs.observe(footer);
  }

  const lcur = $('.lnav [aria-current]');
  if (lcur) lcur.parentElement.scrollLeft = lcur.offsetLeft - lcur.parentElement.offsetLeft - 16;

  /* product reviews: show the rest on demand */
  const moreBtn = $('[data-reviews-more]');
  if (moreBtn) moreBtn.addEventListener('click', () => {
    const g = $('[data-reviews]'); g.classList.add('is-all');
    $$('.prev--more', g).forEach(el => el.classList.add('in'));
    moreBtn.remove();
  });

  /* policy pages: highlight the section in view in the side index */
  const ltoc = $('[data-ltoc]');
  if (ltoc) {
    const tl = $$('a[href^="#s"]', ltoc);
    const lio = new IntersectionObserver(es => es.forEach(en => {
      if (en.isIntersecting) tl.forEach(a => a.classList.toggle('is-active', a.getAttribute('href') === '#' + en.target.id));
    }), { rootMargin: '-25% 0px -65% 0px' });
    $$('.lsec[id]').forEach(s => lio.observe(s));
  }

  /* ---------- scroll motion ---------- */
  if (!reduce) {
    /* heading words rise in, one after another */
    const splitWords = el => {
      let i = 0;
      const walk = node => [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            const o = document.createElement('span'); o.className = 'wd'; o.setAttribute('aria-hidden', 'true');
            const s = document.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++);
            o.appendChild(s); frag.appendChild(o);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
      });
      el.setAttribute('aria-label', el.textContent.trim());
      walk(el);
    };
    const riseIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-risen'); riseIO.unobserve(e.target); } }), { rootMargin: '0px 0px -10% 0px' });
    $$('.h2, .neuro__title, .band__title, .cta__title, .bslide__title, .pdp__title').forEach(el => { splitWords(el); riseIO.observe(el); });
    /* first banner title rises on load */

    /* scroll scrubbed statement: words fill in as you scroll, and empty again going back up */
    const scrub = $('[data-scrub]');
    let words = [];
    if (scrub) {
      const txt = $('[data-scrub-text]', scrub);
      txt.setAttribute('aria-label', txt.textContent.trim());
      txt.innerHTML = txt.textContent.trim().split(/\s+/).map(w => '<span class="sw" aria-hidden="true">' + w + '</span>').join(' ');
      words = $$('.sw', txt);
    }
    const para = $$('[data-parallax]');
    let ticking = false;
    const frame = () => {
      ticking = false;
      const vh = innerHeight;
      if (scrub) {
        const r = scrub.getBoundingClientRect();
        const total = r.height - vh;
        const p = Math.min(1, Math.max(0, -r.top / (total * 0.85)));
        const lit = p * words.length;
        words.forEach((w, k) => w.style.setProperty('--o', (0.14 + 0.86 * Math.min(1, Math.max(0, lit - k))).toFixed(3)));
        scrub.classList.toggle('is-done', p > 0.98);
      }
      para.forEach(el => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const off = (r.top + r.height / 2 - vh / 2) * -Number(el.dataset.parallax);
        el.style.setProperty('--py', off.toFixed(1) + 'px');
      });
    };
    const onS = () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
    addEventListener('scroll', onS, { passive: true });
    addEventListener('resize', onS);
    frame();

    /* ===== motion pack ===== */
    const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

    /* scroll progress line at the very top */
    const prog = document.createElement('div'); prog.className = 'sprog'; prog.setAttribute('aria-hidden', 'true');
    document.body.appendChild(prog);
    let lastY = scrollY, vel = 0;
    const marqs = () => document.getAnimations().filter(a => a.animationName === 'marq' || a.animationName === 'trustMarq');
    const onProg = () => {
      const h = document.documentElement.scrollHeight - innerHeight;
      prog.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0).toFixed(4) + ')';
      /* marquees speed up with scroll and settle back */
      vel = Math.min(6, Math.abs(scrollY - lastY) / 12); lastY = scrollY;
      marqs().forEach(a => { a.playbackRate = 1 + vel; });
    };
    addEventListener('scroll', () => requestAnimationFrame(onProg), { passive: true });
    setInterval(() => { if (vel > 0.01) { vel *= 0.82; marqs().forEach(a => { a.playbackRate = 1 + vel; }); } }, 60);
    onProg();

    /* hero: "15 day" counts up on load */
    const num = $('.hero__num');
    if (num && /^\d+/.test(num.textContent)) {
      const target = parseInt(num.textContent, 10), rest = num.textContent.replace(/^\d+/, '');
      num.setAttribute('aria-label', num.textContent);
      const t0 = performance.now() + 350, dur = 1300;
      const tick = t => {
        const k = Math.min(1, Math.max(0, (t - t0) / dur)), e = 1 - Math.pow(1 - k, 3);
        num.textContent = Math.max(1, Math.round(e * target)) + rest;
        if (k < 1) requestAnimationFrame(tick);
      };
      num.textContent = '1' + rest; requestAnimationFrame(tick);
    }

    /* more things rise in as you scroll, one after another, and their icons draw themselves */
    const groups = ['.trust__list li', '.neuro__idea', '.band__kicker', '.ing li', '.footer__perks > div', '.faqs__list .faq', '.ccard', '.lchip', '.person', '.phero__meta span', '.lnav a'];
    groups.forEach(sel => {
      const els = $$(sel).filter(el => !el.closest('.is-marquee') && !el.classList.contains('reveal'));
      els.forEach((el, k) => { el.classList.add('reveal', 'rv-soft'); el.style.transitionDelay = Math.min(k % 6, 5) * 70 + 'ms'; io.observe(el); });
    });
    $$('.reveal').forEach(el => { if ($('.ic', el)) el.classList.add('draw'); });

    /* hero visual follows the pointer a little */
    const hero = $('.hero');
    if (hero && fine) {
      hero.addEventListener('pointermove', e => {
        const r = hero.getBoundingClientRect();
        hero.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 2 - 1).toFixed(3));
        hero.style.setProperty('--my', ((e.clientY - r.top) / r.height * 2 - 1).toFixed(3));
      });
      hero.addEventListener('pointerleave', () => { hero.style.setProperty('--mx', 0); hero.style.setProperty('--my', 0); });
    }

    if (fine) {
      /* magnetic buttons */
      $$('.btn--lg, .btn--dark, .wa-float').forEach(b => {
        b.addEventListener('pointermove', e => {
          const r = b.getBoundingClientRect();
          b.style.translate = ((e.clientX - r.left - r.width / 2) * 0.18).toFixed(1) + 'px ' + ((e.clientY - r.top - r.height / 2) * 0.28).toFixed(1) + 'px';
        });
        b.addEventListener('pointerleave', () => { b.style.translate = ''; });
      });
      /* product cards tilt toward the pointer */
      $$('.pcard').forEach(c => {
        c.addEventListener('pointermove', e => {
          const r = c.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          c.style.transform = 'perspective(900px) translateY(-6px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 6).toFixed(2) + 'deg)';
          c.style.setProperty('--gx', (x + 0.5) * 100 + '%'); c.style.setProperty('--gy', (y + 0.5) * 100 + '%');
        });
        c.addEventListener('pointerleave', () => { c.style.transform = ''; });
      });
    }
  }
})();
